// start:ng42.barrel
export * from './constants';
export * from './core.module';
export * from './local-storage.service';
export * from './route-reusable-strategy';
export * from './authentication';
export * from './class';
export * from './http';
export * from './service';
// end:ng42.barrel
